import { ManualPendingReview } from '~features/payment/ui/payment-processing/manual-pending-review';
import { PaymentProcessing } from '~features/payment/ui/payment-processing/payment-processing';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~/shared/shadcn/ui/tabs';

interface ManualProcessingTabProps {
  /** When 'pending', opens the Pending Review tab (e.g. from journey modal link). */
  defaultSubTab?: 'history' | 'pending';
}

export function ManualProcessingTab({
  defaultSubTab = 'history',
}: ManualProcessingTabProps) {
  return (
    <Tabs defaultValue={defaultSubTab} className='w-full'>
      <TabsList className='grid w-full max-w-md grid-cols-2'>
        <TabsTrigger value='history'>Payment History</TabsTrigger>
        <TabsTrigger value='pending'>Pending Review</TabsTrigger>
      </TabsList>
      <TabsContent value='history' className='mt-6'>
        <PaymentProcessing type='manual' />
      </TabsContent>
      <TabsContent value='pending' className='mt-6'>
        <ManualPendingReview />
      </TabsContent>
    </Tabs>
  );
}
